var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.schemaLoaded)?_c('form',{on:{"invalid":_vm.handleInvalidation}},[_c('vue-form-generator',{ref:`${_vm.id}-form-ref`,attrs:{"schema":_vm.schema,"model":_vm.model,"options":_vm.formOptions,"form-id":_vm.id},on:{"field-updated":_vm.submitField,"collection-new-updated":_vm.submitCollection,"validated":_vm.handleValidation}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }